import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VatNotice from '../components/VatNotice';
import SEO from '../components/SEO';

const PricingVatPage = () => (
  <div className="min-h-screen bg-white" data-testid="pricing-vat-page">
    <SEO
      title="Pricing & VAT — Zebra One Gallery"
      description="Plain-English explanation of how VAT, the VAT Margin Scheme, EU import VAT and US export zero-rating apply to artworks purchased from Zebra One Gallery, Hampstead."
    />
    <Header />
    <main className="max-w-3xl mx-auto px-6 py-24 sm:py-32">
      <div className="text-xs tracking-[0.3em] uppercase text-neutral-400 mb-3">Buyers' Information</div>
      <h1
        className="font-serif text-4xl sm:text-5xl text-neutral-900 mb-10 leading-tight"
        data-testid="pricing-vat-h1"
      >
        Pricing &amp; VAT
      </h1>
      <VatNotice variant="full" />
    </main>
    <Footer />
  </div>
);

export default PricingVatPage;
